export const MONTHS = {
  JANUARY: 1,
  FEBRUARY: 2,
  MARCH: 3,
  APRIL: 4,
  MAY: 5,
  JUNE: 6,
  JULY: 7,
  AUGUST: 8,
  SEPTEMBER: 9,
  OCTOBER: 10,
  NOVEMBER: 11,
  DECEMBER: 12,
};

export const MONTH_NAMES = {
  [MONTHS.JANUARY]: 'Enero',
  [MONTHS.FEBRUARY]: 'Febrero',
  [MONTHS.MARCH]: 'Marzo',
  [MONTHS.APRIL]: 'Abril',
  [MONTHS.MAY]: 'Mayo',
  [MONTHS.JUNE]: 'Junio',
  [MONTHS.JULY]: 'Julio',
  [MONTHS.AUGUST]: 'Agosto',
  [MONTHS.SEPTEMBER]: 'Septiembre',
  [MONTHS.OCTOBER]: 'Octubre',
  [MONTHS.NOVEMBER]: 'Noviembre',
  [MONTHS.DECEMBER]: 'Diciembre',
};

export default { MONTHS, MONTH_NAMES };
